import _typeof from "@babel/runtime/helpers/typeof";
import React from 'react';
import { ConfluenceIcon } from '@atlaskit/logo/confluence-icon';
import { JiraIcon } from '@atlaskit/logo/jira-icon';
import { CONFLUENCE_GENERATOR_ID, JIRA_GENERATOR_ID } from '../common/constants';
export var isEntityPresent = function isEntityPresent(response) {
  return Boolean(response === null || response === void 0 ? void 0 : response.nounData);
};
export var extractEntity = function extractEntity(response) {
  return response === null || response === void 0 ? void 0 : response.nounData;
};
export var extractEntityEmbedUrl = function extractEntityEmbedUrl(response) {
  var entity = extractEntity(response);
  if (entity && instanceOfDesignEntity(entity)) {
    return entity['atlassian:design'].liveEmbedUrl;
  }
};
export function instanceOfDesignEntity(object) {
  return _typeof(object) === 'object' && object !== null && 'atlassian:design' in object;
}
export var extractEntityProvider = function extractEntityProvider(response) {
  var _response$meta;
  if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && _response$meta.generator)) {
    return undefined;
  }
  var _ref = response.meta.generator,
    icon = _ref.icon,
    id = _ref.id,
    image = _ref.image,
    name = _ref.name;
  if (!name || !icon) {
    throw Error('Link.generator requires a name and icon.');
  }
  var providerIcon;
  switch (id) {
    case CONFLUENCE_GENERATOR_ID:
      providerIcon = /*#__PURE__*/React.createElement(ConfluenceIcon, {
        appearance: "brand",
        size: "xsmall"
      });
      break;
    case JIRA_GENERATOR_ID:
      providerIcon = /*#__PURE__*/React.createElement(JiraIcon, {
        appearance: "brand",
        size: "xsmall"
      });
      break;
    default:
      providerIcon = icon.url;
  }
  return {
    text: name,
    icon: providerIcon,
    id: id,
    image: image ? image : icon.url
  };
};
export var extractEntityIcon = function extractEntityIcon(response) {
  var entity = extractEntity(response);
  var url;
  if (instanceOfDesignEntity(entity)) {
    url = entity === null || entity === void 0 ? void 0 : entity['atlassian:design'].iconUrl;
  }
  return {
    url: url,
    label: entity === null || entity === void 0 ? void 0 : entity.displayName
  };
};